import React, { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc } from "firebase/firestore";
import { storage, firestore as db } from "../Firebase"; // Adjust the import path as necessary

const NewBlog = () => {
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [readTime, setReadTime] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [status, setStatus] = useState("");

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImage(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleRedirect = (e) => {
    e.preventDefault();
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  const handleUpload = async () => {
    if (!image) {
      setStatus("Please select a file first.");
      return;
    }

    try {
      setStatus("Uploading...");

      // 🔼 Upload to Firebase Storage
      const storageRef = ref(storage, `uploads/${image.name}`);
      const snapshot = await uploadBytes(storageRef, image);

      // 🔗 Get download URL
      const downloadURL = await getDownloadURL(snapshot.ref);

      // 📝 Save metadata to Firestore
      await addDoc(collection(db, "files"), {
        name: image.name,
        url: downloadURL,
        uploadedAt: new Date(),
      });

      setStatus("Upload successful!");
    } catch (error) {
      console.error("Upload error:", error);
      setStatus("Upload failed.");
    }
  };

  return (
    <form
      className="card shadow-sm border-0 mb-4 mt-150 p-3"
      style={{ maxWidth: 420 }}
      onSubmit={handleRedirect}
    >
      {image ? (
        <img
          src={image}
          alt="Blog"
          className="card-img-top mb-3"
          style={{
            objectFit: "cover",
            height: "220px",
            borderRadius: "0.5rem",
          }}
        />
      ) : (
        <div
          className="d-flex align-items-center justify-content-center bg-light mb-3"
          style={{ height: "220px", borderRadius: "0.5rem" }}
        >
          <span className="text-muted">No Image Selected</span>
        </div>
      )}
      <div className="mb-3">
        <label className="form-label fw-semibold">Upload Blog Image</label>
        <input
          type="file"
          accept="image/*"
          className="form-control"
          onChange={handleImageChange}
        />
      </div>
      <button onClick={handleUpload} style={{ marginTop: "10px" }}>
        Upload
      </button>
      <p>{status}</p>
      <div className="mb-3">
        <label className="form-label fw-semibold">Title</label>
        <input
          type="text"
          className="form-control"
          placeholder="Blog Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label fw-semibold">Date</label>
        <input
          type="date"
          className="form-control"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label fw-semibold">Read Time (min)</label>
        <input
          type="number"
          className="form-control"
          placeholder="e.g. 5"
          value={readTime}
          onChange={(e) => setReadTime(e.target.value)}
          min="1"
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label fw-semibold">Redirect URL</label>
        <input
          type="url"
          className="form-control"
          placeholder="https://yourblog.com/post"
          value={redirectUrl}
          onChange={(e) => setRedirectUrl(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <div className="card-title fw-bold">{title}</div>
        <div
          className="card-subtitle text-muted"
          style={{ fontSize: "0.95rem" }}
        >
          {date && readTime ? `${date} • ${readTime} min read` : ""}
        </div>
      </div>
      <button
        className="btn btn-primary w-100"
        type="submit"
        disabled={!title || !date || !readTime || !redirectUrl}
      >
        Read More
      </button>
    </form>
  );
};

export default NewBlog;
